import gql from "graphql-tag";

export const BACKGROUND_IMAGES = gql`
  query pageDatasLanding {
    pageDatas {
      loginBackgroundImages {
        urlBackgroundDesktop1x
        urlBackgroundDesktop2x
        urlBackgroundMobile1x
      }
    }
  }
`;

export const LANDING_PAGE = gql`
  query landingPage($landingPageUrlName: String!) {
    landingPage(urlName: $landingPageUrlName){
      backGroundImage{ 
        desktop
        mobile
        tablet
      }
      backGroundAlt
      metaTitle
      catchText{
        text
        bold
        italic
      }
      univers
      descriptionUniverse
    }
  }
`;


export const GET_SALES_BY_UNIVERSE = gql`
  query getSalesByUnivers($universe: String) {
    salesByUniverse(universe: $universe) {
      edges {
        node {
          logoUrl
          name
        }
      }
    }
  }
`;
